import * as bootstrap from 'bootstrap';
(window as any).bootstrap = bootstrap;
